import "./App.css";
import React, { useState, useEffect } from "react";
import SingleCard from "./components/SingleCard";
import ConfettiExplosion from "react-confetti-explosion";
import { AdMob, BannerAdPosition, BannerAdSize } from "@capacitor-community/admob";

const cardImages = [
  { src: "/img/helmet-1.png", matched: false },
  { src: "/img/potion-1.png", matched: false },
  { src: "/img/ring-1.png", matched: false },
  { src: "/img/scroll-1.png", matched: false },
  { src: "/img/shield-1.png", matched: false },
  { src: "/img/sword-1.png", matched: false },
];
function App() {
  const [cards, setCards] = useState([]);
  const [turns, setTurns] = useState(0);
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);
  // shuffle cards
  const shuffleCards = React.useCallback(() => {
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5)
      .map((card) => ({ ...card, id: Math.random() }));

    setChoiceOne(null);
    setChoiceTwo(null);
    setCards(shuffledCards);
    setTurns(0);
  },[]);

  // handle a choice
  const handleChoice = (card) => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
  };

  // compare 2 selected cards
  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src == choiceTwo.src) {
        setCards((prevCards) => {
          return prevCards.map((card) => {
            if (card.src === choiceOne.src) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
        resetTurn();
      } else {
        setTimeout(() => {
          resetTurn();
        }, 1000);
      }
    }
  }, [choiceOne, choiceTwo]);

  // reset choices & increase turn
  const resetTurn = () => {
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns((prevturns) => prevturns + 1);
    setDisabled(false);
  };
  // start a new game when the page load
  useEffect(() => {
    shuffleCards();
  }, []);
  const allMatched = cards.every(img=> img.matched);

  async function initialize(){
    AdMob.initialize({
      requestTrackingAuthorization: true,
      testingDevices: ["00d9e467-ff5a-47cb-a55d-286f71b54fb6"],
      // initializeForTesting: true
    })
  }

  async function showBanner(){
    const options = {
      adId: 'ca-app-pub-3552608404768601/6897618943',
      adSize: BannerAdSize.ADAPTIVE_BANNER,
      position: BannerAdPosition.BOTTOM_CENTER,
      margin: 0,
     // isTesting: true
      // npa: true
    };
    AdMob.showBanner(options);
  }
  async function showInterstitial() {
    const options = {
      adId: 'ca-app-pub-3552608404768601/6897618943',
     // isTesting: true
      // npa: true
    };
    await AdMob.prepareInterstitial(options);
    await AdMob.showInterstitial();
  }

  useEffect(()=>{
    initialize();
    showBanner();
  },[]);
  return (
    <div className="App">
      <h1>Flip and find</h1>
      <button onClick={shuffleCards}>New Game</button>

      <div className="card-grid">
        {cards.map((card) => (
          <SingleCard
            key={card.id}
            card={card}
            handleChoice={handleChoice}
            flipped={card === choiceOne || card === choiceTwo || card.matched}
            disabled={disabled}
          />
        ))}
      </div>
      {allMatched && <CompletedOverlay shuffleCards={()=>{
        shuffleCards();
        showInterstitial();
      }}/>}
    </div>
  );
}

export default App;

function CompletedOverlay(props){
  return(
    <div className="overlay">
      <h1>You won !!</h1>
      <button onClick={props.shuffleCards} className="finishButton">New Game</button>
      <ConfettiExplosion/>
    </div>

  )
}